export default __webpack_public_path__ + "static/media/img_step_lucia07-01.0d42fb2e.png";